import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface DynamicDisclosureState {
    checkedDisclosures: { [disclosureOrder: number]: boolean };
    base64Signature: string | null;
    hasSigned: boolean;
    disclosureToken: string | null;
}

function useDynamicDisclosureData() {
    const [dynamicDisclosureState, setDynamicDisclosureState] = useState<DynamicDisclosureState>({
        checkedDisclosures: {},
        base64Signature: null,
        hasSigned: false,
        disclosureToken: null,
    });

    const updateDisclosureCheckbox = (order: number, checked: boolean) => {
        setDynamicDisclosureState(prev => ({
            ...prev,
            checkedDisclosures: {
                ...prev.checkedDisclosures,
                [order]: !checked,
            },
        }));
    };

    const setSignature = (base64Signature: string | null) => {
        setDynamicDisclosureState(prev => ({
            ...prev,
            base64Signature,
            hasSigned: !!base64Signature,
        }));
    };

    const setDisclosureToken = (token: string | null) => {
        setDynamicDisclosureState(prev => ({
            ...prev,
            disclosureToken: token,
        }));
    };

    const resetDynamicDisclosures = () => {
        setDynamicDisclosureState({
            checkedDisclosures: {},
            base64Signature: null,
            hasSigned: false,
            disclosureToken: null,
        });
    };

    return {
        dynamicDisclosureState,
        updateDisclosureCheckbox,
        setSignature,
        setDisclosureToken,
        resetDynamicDisclosures,
    };
}

export const DynamicDisclosureStore = createStore(useDynamicDisclosureData);

export type DynamicDisclosureStore = ReturnType<typeof useDynamicDisclosureData>;
